// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticCount_container__3Cotv","multiple":"StaticCount_multiple__1QSCV","separator":"StaticCount_separator__IJPwZ","header":"StaticCount_header__3y34C"};